import './admin.scss';

jQuery(document).ready(function () {
	const $ = jQuery;

	//const {ajaxurl, nonce} = devnet_snap_blocks_script_data;
});
